import { useEffect, useState } from "react"
import { ResultItem } from "./results.component"

const isMatching = (text: string, searchValue: string): boolean =>
  text.toLowerCase().includes(searchValue.toLowerCase())

const useReducedItems = ({
  items,
  value,
  max = 5,
}: {
  items: ResultItem[]
  value: string
  max?: number
}): ResultItem[] => {
  const [reducedItems, setReducedItems] = useState<ResultItem[]>([])

  useEffect(() => {
    if (value?.length < 1) {
      setReducedItems([])
    } else {
      const reducedList = items
        .filter(({ title, subtitle, context }) =>
          isMatching(`${title} ${subtitle} ${context}`, value)
        )
        .slice(0, max)
      setReducedItems(reducedList)
    }
  }, [value])

  return reducedItems
}

export default useReducedItems
